import { Cirus } from '@/classes/Http';
import { AxiosResponse } from 'axios';
import { objectToQuery } from '../../ObjectToQuery';
import { InvoiceType } from '../Commands/PublishBoughtInvoice.command'

class getInstanceTransactionParams {
    types: InvoiceType[] = [InvoiceType.BOUGHT, InvoiceType.SOLD, InvoiceType.INCOME, InvoiceType.COST];
    page?: number;
    search?: string;
}
export class GetInstanceTransactionResponse{
    id: string;
    description: string;
    product_id: string;
    product_name: string;
    type: InvoiceType;
    dateCreated: Date;
    datePaid: Date;
    value: number;
    value_without_off: number;
    count: number;
}
export function getInstanceTransactions (instance_id: number, params: getInstanceTransactionParams): Promise<AxiosResponse<Promise<{transactions: GetInstanceTransactionResponse[],count: number}>>>{
    const path = `/instance/${instance_id}/transactions?${objectToQuery(params)}`;
    return Cirus.get(path);
}